export default (theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
    },
    popoverContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        maxWidth: 280,
    },
});
